export default __webpack_public_path__ + "static/media/cert-fsi-hkgcsmeaa.c77d2a1a.jpg";